import React from 'react';
import { motion } from 'framer-motion';
import { Eye, ShieldCheck, Wind, Heart } from 'lucide-react';
const cards = [{
  icon: Eye,
  title: 'Más claridad',
  desc: 'Sabes qué observar y cuándo empezar',
  color: 'text-sage',
  bg: 'bg-sage/10'
}, {
  icon: ShieldCheck,
  title: 'Más seguridad',
  desc: 'Entiendes qué hacer y qué evitar',
  color: 'text-olive',
  bg: 'bg-olive/10'
}, {
  icon: Wind,
  title: 'Más calma',
  desc: 'Reduces la ansiedad y la sobreinformación',
  color: 'text-mauve',
  bg: 'bg-mauve/10'
}, {
  icon: Heart,
  title: 'Más conexión',
  desc: 'Conviertes la mesa en un espacio de aprendizaje y vínculo',
  color: 'text-terracotta',
  bg: 'bg-terracotta/10'
}];
export function Benefits() {
  return <section className="py-24 bg-cream" data-id="element-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <motion.h2 className="text-4xl font-serif text-charcoal mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-19">
            Lo que cambia cuando dejas de improvisar
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-20">
          {cards.map((card, i) => <motion.div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-sand hover:shadow-md transition-shadow" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-21">
              <div className={`w-12 h-12 rounded-full ${card.bg} flex items-center justify-center mb-6`} data-id="element-22">
                <card.icon className={`w-6 h-6 ${card.color}`} data-id="element-23" />
              </div>
              <h3 className="text-xl font-serif text-charcoal mb-3" data-id="element-24">
                {card.title}
              </h3>
              <p className="text-warmGray leading-relaxed" data-id="element-25">{card.desc}</p>
            </motion.div>)}
        </div>

        <motion.div className="mt-16 text-center max-w-2xl mx-auto" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} data-id="element-26">
          <p className="text-2xl font-serif text-charcoal italic leading-relaxed" data-id="element-27">
            "No se trata de hacerlo perfecto. Se trata de empezar con más
            criterio, más paz mental y más confianza."
          </p>
        </motion.div>
      </div>
    </section>;
}